import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';


export interface JcMetaLabelProps extends JcCommonProps {
  readonly label: string;
}


/** A single-line metadata line (regular weight, sm) for the secondary lines of rows and cards. */
export const JcMetaLabel: React.FunctionComponent<JcMetaLabelProps> = (props: JcMetaLabelProps) => {

  const commonProps = JcUtils.commonProps(props, ["jc-meta-label"]);

  return <span {...commonProps}>
    {props.label}
  </span>
}
